var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.base)},[_c('div',{class:_vm.getCss('sharePageBtn'),style:(_vm.shareBtnImage),on:{"click":function($event){return _vm.clickBtn()}}},[_c('div',{class:_vm.getCss('btnText')})])])}
var staticRenderFns = []

export { render, staticRenderFns }